module.exports = __webpack_public_path__ + "img/appstore.313ef441.png";